import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import '../modules/opening-hours/opening-hours.js'
import '@shoelace-style/shoelace/dist/components/card/card.js'

@customElement('app-opening-hours')
export class AppBusinessHours extends LitElement {
  @property({ type: String }) restaurantId = ''
  @property({ type: String }) secretKey = ''

  static styles = css`
    :host {
      display: block;
      padding: 16px;
      font-family: Roboto, Inter, system-ui, Avenir, Helvetica, Arial, sans-serif;
      color: #333;
    }

    sl-card {
      margin-bottom: 16px;
      border-radius: 18px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    h1 {
      text-align: center;
      font-family: 'Asap Condensed';
    }
  `

  render() {
    return html`
      <opening-hours .restaurantId="${ this.restaurantId }" 
      key="${ this.secretKey }"></opening-hours>       
    `
  }
}